import { COOKIE_CHANGED } from './actionTypes';

export const broadcastCookieChange = () => ({
  type: COOKIE_CHANGED,
  payload: Math.random(),
});
